import { Unsubscribe } from "firebase/firestore";
import { StateCreator } from "zustand";
import { Role, Tenant } from "@/models";
import { tenant } from "@/repositories/tenant";
import { UserSlice } from "@/stores/user.slice";
import { sentry } from "@/services/sentry";

export interface TenantSlice {
  tenant: Tenant | undefined;
  tenantRole: Role | undefined;
  subscribeTenant: (tenantId: string) => Promise<void>;
  tenantSubscription: Unsubscribe | undefined;
  unsubscribeTenant: () => void;
  resetTenant: () => void;
}

const initialSlice: TenantSlice = {
  tenant: undefined,
  tenantRole: undefined,
  tenantSubscription: undefined,
  subscribeTenant: async () => {},
  unsubscribeTenant: () => {},
  resetTenant: () => {},
};

export const createTenantSlice: StateCreator<
  TenantSlice & UserSlice,
  [],
  [],
  TenantSlice
> = (set, get) => ({
  ...initialSlice,
  resetTenant: () => {
    set({ ...initialSlice });
  },

  subscribeTenant: async (tenantId: string) => {
    if (get().tenantSubscription) {
      get().unsubscribeTenant();
    }

    const userId = get().user?.uid;
    const userEmail = get().user?.email;
    if (!userId || !userEmail) {
      return;
    }

    sentry.setUser({
      email: userEmail,
      id: userId,
      tenantId: tenantId,
    });

    const subscription = await tenant.subscribeTenant(tenantId, async (doc) => {
      if (!doc) {
        set({ tenant: undefined });
        return;
      }

      const userRole: Role = doc.adminUserIds.includes(userId)
        ? "admin"
        : "user";

      set({
        tenant: doc,
        tenantRole: userRole,
      });
    });
    set({ tenantSubscription: subscription });
    return;
  },
  unsubscribeTenant: () => {
    const unsubscribe = get().tenantSubscription;
    if (unsubscribe) unsubscribe();
    set({ tenantSubscription: undefined });
  },
});
